// extracted by mini-css-extract-plugin
export default {"card":"o4-z"};